 
import { Entity } from './entity';
import { City } from './city';
import { Division } from './division';

export class Street extends Entity {
    public id: number;
    public name: string;

  }  